import { createSelector } from 'reselect';

import type { State } from 'reducers';
import type DonationMatchingRule from 'entities/donationMatchingRule/model';
import type { DonationMatchingRuleState } from 'entities/donationMatchingRule/reducer';

const sortFunction = (a: DonationMatchingRule, b: DonationMatchingRule) =>
  (+a.startingAt || +a.createdAt) - (+b.startingAt || +b.createdAt);

export const selectDonationMatchingRulesState = (state: State): DonationMatchingRuleState =>
  state.get('entities').donationMatchingRule;

export const selectDonationMatchingRules = createSelector(
  selectDonationMatchingRulesState,
  (donationMatchingRules) => donationMatchingRules.sort(sortFunction)
);

export const selectDonationMatchingRuleById = createSelector(
  selectDonationMatchingRules,
  (_state: State, donationMatchingRuleId: string) => donationMatchingRuleId,
  (donationMatchingRules, donationMatchingRuleId): DonationMatchingRule | undefined =>
    donationMatchingRules.get(donationMatchingRuleId)
);
